import fetcher from "@/api/axiosClient";

class AuthenApi {
  static login = async (data, csrfToken) => {
    return fetcher(`Auth/Login`, {
      method: "POST",
      data,
      headers: {
        'Cf-Token': csrfToken
      }
    });
  };

  static getProfile = async (token) => {
    if (!token) return;
    return fetcher(`Auth/Profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  static changePassword = async (data, token) => {
    if (!token) return;
    return fetcher(`Auth/ChangePassword`, {
      method: "POST",
      data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  static updateAccount = async (data, token, csrkToken) => {
    return fetcher(`Auth/UpdateProfile`, {
      method: "POST",
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
        'Cf-Token': csrkToken
      },
    });
  };

  static updateProfileCV = async (data) => {
    const token = localStorage.getItem("token");
    return fetcher(`Auth/UpdateProfileCV`, {
      method: "POST",
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  static getSkill = async (pageIndex, pageSize, params) => {
    const token = localStorage.getItem("token");
    return fetcher(`Skill?pageIndex=${pageIndex}&pageSize=${pageSize}`, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  static confirmEmail = async (data) => {
    return fetcher(`Auth/ConfirmEmail`, {
      method: "POST",
      data,
    });
  };

  static register = async (data, csrfToken) => {
    return fetcher(`Auth/Register`, {
      method: "POST",
      data,
      headers: {
        'Cf-Token': csrfToken
      }
    });
  }
}

export default AuthenApi;
